import { dataBulb } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBulb = /*#__PURE__*/createIcon(dataBulb)
export default IconBulb
